import React, { useEffect, useState } from 'react';

// Replacement for react-transition-group's CSSTransition (classNames="fade", unmountOnExit).
const FadeTransition = ({ in: inProp, timeout = 600, children }) => {
  const [mounted, setMounted] = useState(inProp);
  const [phase, setPhase] = useState(inProp ? 'enter-done' : '');

  useEffect(() => {
    let t;
    let raf;
    if (inProp) {
      setMounted(true);
      setPhase('enter');
      raf = requestAnimationFrame(() => {
        setPhase('enter enter-active');
        t = setTimeout(() => setPhase('enter-done'), timeout);
      });
    } else {
      setPhase('exit');
      raf = requestAnimationFrame(() => {
        setPhase('exit exit-active');
        t = setTimeout(() => setMounted(false), timeout);
      });
    }
    return () => {
      cancelAnimationFrame(raf);
      clearTimeout(t);
    };
  }, [inProp, timeout]);

  if (!mounted) return null;

  const child = React.Children.only(children);
  const fadeClasses = phase
    .split(' ')
    .filter(Boolean)
    .map((c) => `fade-${c}`)
    .join(' ');
  return React.cloneElement(child, {
    className: [child.props.className, fadeClasses].filter(Boolean).join(' '),
  });
};

export default FadeTransition;
